import { SiteLink } from "shared/components/SiteLink";
import { useRouter } from "next/router";
import styles from "./SearchResultItem.module.css";
import { useAppContext } from "shared/utils/useAppContext";

export const SearchResultItem = ({ description, href, title, type }) => {
  const { locale } = useRouter();
  const { createInternalHref } = useAppContext();
  const link = `${createInternalHref({
    locale,
    href,
    type,
  })}`;

  return (
    <SiteLink className={styles.container} href={href || ""} type={type}>
      <h2>{title}</h2>
      {typeof description === "string" && <p>{description}</p>}
      <p className={styles.link}>{link}</p>
    </SiteLink>
  );
};
